import React, { useEffect, useRef, useState } from 'react';
import TitleMultipleQuotesStyle from './style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCircleLeft,
    faCircleRight,
    faEye,
} from '@fortawesome/free-solid-svg-icons';
import TitleQuoteDetail from '../titleQuoteDetail';
import { Flex, Modal } from 'antd';
import { routerQuoteDetailData } from 'src/const/enum';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toggleEditQuoteSelector } from 'src/redux/selectors/toggleEditQuoteSelector';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';
import { multipleQuotesSelector } from 'src/redux/selectors/multipleQuotesSelector';
import { updateMultipleQuotesAction } from 'src/redux/actions/multipleQuotesAction';
import useIsPreview from 'src/hooks/useIsPreview';
import CompareQuotesComponent from '../compareQuotes';

declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
    }
}

const TitleMultipleQuotesComponent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const isEdit = useSelector(toggleEditQuoteSelector);
    const isPreview = useIsPreview();
    const [visible, setVisible] = useState(false);
    const { title = '' } = useSelector(quoteDetailSelector);
    const searchParams = new URLSearchParams(location.search);
    const multipleQuotes = searchParams.get('multipleQuotes');

    const { ids: quotesArray = [], currentId } = useSelector(
        multipleQuotesSelector,
    );
    const isMultipleQuotes = quotesArray.length > 1;
    const currentIndex = quotesArray.indexOf(currentId || '');

    const elementRef = useRef<HTMLDivElement | null>(null);
    const [isSticky, setIsSticky] = useState<boolean>(false);
    const [height, setHeight] = useState<number>(0);

    useEffect(() => {
        const handleScroll = () => {
            if (!elementRef.current) return;
            const top = elementRef.current.getBoundingClientRect().top;
            setIsSticky(top <= (isPreview ? 64 : 0));
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, [isPreview]);

    useEffect(() => {
        const sectionTitle: any =
            document.getElementsByClassName('box-multiple-title');
        if (sectionTitle && sectionTitle.length > 0) {
            setHeight(isSticky ? sectionTitle[0].offsetHeight : 0);
        }
    }, [isSticky, title]);

    const handleCompareQuotes = () => {
        setVisible(true);

        if (
            !localStorage.getItem('access_token') &&
            typeof window !== 'undefined' &&
            typeof window.gtag === 'function'
        ) {
            window.gtag('event', 'click_compare_quote', {
                event_category: 'Button',
                event_label: 'Compare Quotes',
                value: 1,
                page_location: window.location.href,
                page_path: window.location.pathname,
            });
        }
    };

    const getPathName = () => {
        return 'introduction';
    };

    const handleBack = () => {
        if (!isEdit) {
            let idQuote;
            if (currentIndex > 0) {
                idQuote = quotesArray[currentIndex - 1];
            } else {
                idQuote = quotesArray[quotesArray.length - 1];
            }
            if (isPreview) {
                navigate(
                    `/quoteDetail/${getPathName()}?id=${idQuote}&multipleQuotes=${multipleQuotes}`,
                );
            } else {
                navigate(
                    `/multipleQuotes/${getPathName()}?id=${searchParams.get(
                        'id',
                    )}`,
                );
                dispatch(
                    updateMultipleQuotesAction({
                        currentId: idQuote,
                    }),
                );
            }
        }
    };

    const handleNext = () => {
        if (!isEdit) {
            let idQuote;
            if (currentIndex < quotesArray.length - 1) {
                idQuote = quotesArray[currentIndex + 1];
            } else {
                idQuote = quotesArray[0];
            }

            if (isPreview) {
                navigate(
                    `/quoteDetail/${getPathName()}?id=${idQuote}&multipleQuotes=${multipleQuotes}`,
                );
            } else {
                navigate(
                    `/multipleQuotes/${getPathName()}?id=${searchParams.get(
                        'id',
                    )}`,
                );
                dispatch(
                    updateMultipleQuotesAction({
                        currentId: idQuote,
                    }),
                );
            }
        }
    };

    const getSubTitle = () => {
        return routerQuoteDetailData.find((router) =>
            location.pathname.includes(router.path),
        )?.title;
    };

    const renderBoxTitle = () => (
        <>
            {!isMultipleQuotes && (
                <div className="title-detail">
                    <div className="container-ydp">
                        <TitleQuoteDetail
                            isEdit={isEdit}
                            titleQuoteDetail={title}
                        />
                    </div>
                </div>
            )}

            {/* {getSubTitle() && (
                <div className="sub-title">
                    <div className="container-ydp">{getSubTitle()}</div>
                </div>
            )} */}
        </>
    );

    const renderBoxTitleMultipleQuotes = () => (
        <div
            ref={elementRef}
            className={isSticky ? 'sticky-active' : ''}
            style={{
                paddingTop: `${height}px`,
            }}
        >
            <div className="box-multiple-title">
                <div className="container-ydp">
                    <div className="box">
                        <Flex className="text-current" align="center" gap={12}>
                            <span>
                                QUOTE {currentIndex + 1}/{quotesArray.length}
                            </span>
                            <FontAwesomeIcon
                                icon={faCircleLeft}
                                className={`icon-circle ${
                                    isEdit ? 'disabled' : ''
                                }`}
                                onClick={handleBack}
                            />
                            <FontAwesomeIcon
                                icon={faCircleRight}
                                className={`icon-circle ${
                                    isEdit ? 'disabled' : ''
                                }`}
                                onClick={handleNext}
                            />
                        </Flex>
                        <div
                            className="text-compare"
                            onClick={handleCompareQuotes}
                        >
                            <FontAwesomeIcon
                                icon={faEye}
                                className="icon-eye"
                            />{' '}
                            <span>Compare your quotes</span>
                        </div>
                    </div>
                    <TitleQuoteDetail
                        isEdit={isEdit}
                        titleQuoteDetail={title}
                        className="multiple-title"
                    />
                </div>
            </div>
        </div>
    );

    return (
        <TitleMultipleQuotesStyle
            className={isMultipleQuotes ? 'multiple' : ''}
        >
            {isMultipleQuotes && renderBoxTitleMultipleQuotes()}
            {renderBoxTitle()}
            <Modal
                open={visible}
                onCancel={() => setVisible(false)}
                footer={null}
                width={'100%'}
                className="modal-compare"
                closable={false}
            >
                <CompareQuotesComponent onClose={() => setVisible(false)} />
            </Modal>
        </TitleMultipleQuotesStyle>
    );
};

export default TitleMultipleQuotesComponent;
